<ng-template #contentGenerate let-modal>
  <div class="modal-content">
    <div class="modal-header p-3">
      <h4 class="card-title mb-0">Generate New Report</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="modal.close()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="generateForm" (ngSubmit)="onGenerateSubmit()">

        <div class="mb-3">
          <label class="form-label">Template <span class="text-danger">*</span></label>
          <ng-select [items]="templates"
            bindLabel="name"
            placeholder="Select Template"
            formControlName="template"
            [ngClass]="{ 'is-invalid': submitted && f['template'].errors }">
          </ng-select>
          <div class="invalid-feedback">Please select a template</div>
        </div>

        <div class="mb-3">
          <label class="form-label">Languages (Max 2) <span class="text-danger">*</span></label>
          <ng-select [items]="languagesList"
            [multiple]="true"
            [maxSelectedItems]="2"
            bindLabel="name"
            placeholder="Select Languages"
            formControlName="languages"
            [ngClass]="{ 'is-invalid': submitted && f['languages'].errors }">
          </ng-select>
          <div class="invalid-feedback">Please select at least one language</div>
        </div>

        <div class="mb-3">
          <label class="form-label">Classification <span class="text-danger">*</span></label>
          <ng-select [items]="classificationOptions"
            placeholder="Select Classification"
            formControlName="classification"
            [ngClass]="{ 'is-invalid': submitted && f['classification'].errors }">
          </ng-select>
          <div class="invalid-feedback">Please select classification</div>
        </div>

        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="form-label">Subject</label>
            <input type="text" class="form-control" placeholder="Anonymous" formControlName="subject" maxlength="50">
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Source Material</label>
            <input type="text" class="form-control" placeholder="Video Analysis" formControlName="source_material" maxlength="50">
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label">Description / Video Context <span class="text-danger">*</span></label>
          <textarea class="form-control"
            rows="4"
            placeholder="Explain the purpose of the video..."
            formControlName="video_context"
            maxlength="250"
          [ngClass]="{ 'is-invalid': submitted && f['video_context'].errors }"></textarea>

          <div class="text-end mt-1">
            <span class="text-muted small">
              {{ generateForm.get('video_context')?.value?.length || 0 }} / 250
            </span>
          </div>

          <div class="invalid-feedback">Please provide a description (max 250 chars)</div>
        </div>

        <div class="text-end">
          <button type="button" class="btn btn-light me-2" (click)="modal.close()">Cancel</button>
          <button type="submit" class="btn btn-primary btn-load" [disabled]="spinner">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Generate Report</span>
            </span>
          </button>
        </div>

      </form>
    </div>
  </div>
</ng-template>

<ng-template #responseModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="mt-2">
        @if (success) {
          <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
        }
        @if (!success) {
          <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
        }
        <h4 class="mb-3 mt-4">{{ message }}</h4>
        @if (report_id) {
          <button class="btn btn-outline-info" (click)="closeModal()">
            <i class="ri-arrow-right-fill align-middle"></i> Go to the Report
          </button>
        }
        @if (reanalyze) {
          <button type="button" class="btn btn-primary btn-load" [disabled]="spinner" (click)="reanalyzeSubmit()">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Re-Analyze {{ activity_type | titlecase }}</span>
            </span>
          </button>
        }
      </div>
    </div>
  </div>
</ng-template>